import { useEffect, useMemo } from "react";
import { useRouter } from "next/router";
import MainLayout from "@/Component/MainLayout";
import Breadcrumbs from "@/Component/Common/Breadcrumbs";
import FaqSection from "@/Component/Common/FaqSection";
import CustomerReviews from "@/Component/Common/CustomerReviews";
import DownloadAdventure from "./DownloadAdventure";
import styles from "./DownloadApp.module.css";
import { APP_STORE_LINKS, getDownloadAppFaq } from "./downloadAppData";

function detectAppRedirectTarget() {
  if (typeof window === "undefined") return APP_STORE_LINKS.website;

  const userAgent =
    navigator.userAgent || navigator.vendor || window.opera || "";
  const lowerUA = userAgent.toLowerCase();

  if (lowerUA.includes("android")) return APP_STORE_LINKS.android;
  if (
    lowerUA.includes("iphone") ||
    lowerUA.includes("ipad") ||
    lowerUA.includes("ipod")
  ) {
    return APP_STORE_LINKS.ios;
  }

  return APP_STORE_LINKS.website;
}

export default function DownloadApp() {
  const router = useRouter();

  const isIndia = useMemo(() => {
    const path = (router.asPath || "").split("?")[0];
    return path === "/in" || path.startsWith("/in/");
  }, [router.asPath]);

  const faqItems = useMemo(() => getDownloadAppFaq(isIndia), [isIndia]);

  useEffect(() => {
    if (router.query.redirect !== "true") return;
    window.location.href = detectAppRedirectTarget();
  }, [router.query.redirect]);

  return (
    <MainLayout hideHeader>
      <Breadcrumbs />
      <DownloadAdventure />
      <CustomerReviews
        moduleType="Holiday"
        title={
          isIndia
            ? "This Is What Satisfied Travelers Sound Like!"
            : "What Travelers Are Saying About Our App"
        }
        subtitle=""
        viewAllHref="/testimonials"
      />
      <FaqSection
        items={faqItems}
        className={styles.faqSection}
      />
    </MainLayout>
  );
}
